<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('preQualify', [
      'setContext',
      'ready',
      'getLastState',
      'error',
      'init',
      'openModal',
      'onResize',
    ]),
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => this.onResize(document.body.clientHeight + 20), 500);
    });
  },
};
</script>
